import axios from "axios";
import { beautyBaseUrl } from "network";
const token = localStorage.getItem("tokenf");
export const verifyBeauticianDocumentApi = async (payload) => {
  const response = await axios.post(`${beautyBaseUrl}/beautician/verify-document`, payload, {
    withCredentials: true,
    headers: {
    Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};


